<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.receipt') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <base-table
        v-else
        :pagination="$store.state.app.pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th style="min-width: 100px;">{{ $t('documents.rt') }}</th>
              <th>{{ $t('message.reference') }}</th>
              <th>{{ $t('message.customer') }}</th>
              <th>{{ $t('message.productlist') }}</th>
              <th>{{ $t('message.grandtotal') }}</th>
              <th>{{ $t('message.createdat') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="receipts.length === 0"
                colspan="6"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in receipts"
              :key="index"
            >
              <td>
                <router-link-custom
                  :to="{name: 'AccountsReceiptEdit', query: {
                    rt_id: item.rt_id,
                    rt_code: item.rt_code
                  }}"
                  :text="item.rt_code"
                  :to_appid="12"
                  :current_appid="12"/>
              </td>
              <td>
                <router-link-custom
                  v-if="item.reference.invoice"
                  :to="{name: 'AccountsInvoiceEdit', query: {
                    in_id: item.reference.invoice.in_id,
                    in_code: item.reference.invoice.in_code
                  }}"
                  :text="item.reference.invoice.in_code"
                  :to_appid="12"
                  :current_appid="12"/>
              </td>
              <td>
                <router-link-custom
                  v-if="item.customer"
                  :to="{name: 'ContactCustomerEdit', query: {cus_id: item.customer.customer_id, cus_name: item.customer.customer_name}}"
                  :text="item.customer.customer_name"
                  :to_appid="11"
                  :current_appid="12"
                  :disabled="item.customer.is_deleted == true" />
              </td>
              <td>
                <item-list :orders="item.orders" />
              </td>
              <td>
                {{ getNumber(getTotal(item.orders).payment) }}
              </td>
              <td>
                {{ getDate(item.created_at) }}
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'

export default {
  data () {
    return {
      ready: false,
      query: {
        page: this.$route.query.page || 1,
        status: this.$route.query.status || 'all',
      },
    }
  },
  computed: {
    ...mapGetters({
      receipts: 'getReceipts',
      getReceiptStatus: 'getReceiptStatus',
      getPaymentStatus: 'getPaymentStatus',
    }),
  },
  watch: {
    ready () {
      if (this.ready == true) {
        this.showFinish(this.$Progress)
      }
    },
    'query.status': {
      handler: function () {
        if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
          $('button.filter').dropdown('toggle')
        }
        this.fetchData()
      },
      deep: true,
    },
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = 1
        this.query.status = 'all'
        this.fetchData()
      }
    },
  },
  created () {
    this.fetchData()
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.accounts.title'),
      current: {
        app_name: 'accounts',
        app_id: 12,
        module_id: 5,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 3,
      submenuAtIdx: 0,
    })
  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearReceipts'])
  },
  methods: {
    async updateReceiptStatus (data) {
      let res = await this.$store.dispatch('updateReceiptStatus', { rt_id: data.rt_id, status: data.status })
      this.showFinish(this.$Progress)
    },
    async fetchData () {
      this.updateUrl()
      this.ready = false
      await this.$store.dispatch('getReceipts', {
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
        status: (() => {
          return this.query.status !== 'all'
            ? this.query.status
            : null
        })(),
      })
      this.ready = true
    },
    handlePageChange (pageNum = 1) {
      this.query.page = pageNum
      this.fetchData()
    },
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.dropdown > button {
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/accounts/receipt/All.vue